// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"450":"d36721ab","591":"b24c020e"}[chunkId] + ".chunk.css";
};